import HeroBasic from '../components/HeroBasic'
import Card from '../components/Card'
import List from '../components/List'

function Uses() {
    var heroTitle = "Potential and Suggested Uses"
    var heroSubtitle = "How the data can support public-interest work."

    var cardHeader = "Suggested Uses"

    var uses = [
        "Citizen suits",
        "Investigative journalism",
        "Policy analysis",
        "Community advocacy",
        "Academic research",
    ]

    return (
        <div>
            <HeroBasic title={heroTitle} subtitle={heroSubtitle} />
            <Card header={cardHeader}>
                <List items={uses} />
            </Card>
        </div>
    )
}

export default Uses